@if (!loading) {
  <app-metrics-card
    class="half-width-card"
    [header]="header"
    [cardImage]="cardImage"
    [currentPeriod]="deviceSpeedScoreInfo.currentScore"
    [previousPeriod]="deviceSpeedScoreInfo.previousScore"
    [currentAgeText]="scoreAgeText"
    >
    <div header-content class="split-card right">
      <div class="spacing">
        <img src="{{ checkImage }}" alt="" />
        {{ deviceSpeedScoreInfo.passedRules }}
        {{ 'ANALYTICS.SPEED_SCORE_MODAL.SUBTITLES.PASSED_RULES' | translate }}
      </div>
      <div class="spacing">
        <img src="{{ warningImage }}" alt="" />
        {{ deviceSpeedScoreInfo.opportunities }}
        {{ 'ANALYTICS.SPEED_SCORE_MODAL.SUBTITLES.OPPORTUNITIES' | translate }}
      </div>
    </div>
    <div header-content class="chart">
      @if (hasEnoughData) {
        <ngx-charts-line-chart
          class="force-hover-state"
          [gradient]="false"
          [results]="deviceSpeedScoreInfo.scoreHistory"
          [animations]="false"
          [xAxis]="true"
          [xAxisTickFormatting]="formatMonthString"
          [yAxis]="true"
          [yAxisTickFormatting]="formatYAxisScale"
          [showYAxisLabel]="true"
          [yAxisLabel]="yLabel"
          [schemeType]="schemeType"
          [scheme]="schemeColor"
          >
          <ng-template #tooltipTemplate let-model="model">
            @if (model) {
              <div class="chart-layout-top">
                {{ model.series.key | translate }}
                {{ ' &bull; ' + model.name.toLocaleDateString() }}
              </div>
            }
            @if (model) {
              <div class="chart-layout-bottom">
                {{ model.value }}
              </div>
            }
          </ng-template>
          <ng-template #seriesTooltipTemplate let-model="model">
            @if (model[0]) {
              <div class="chart-layout-top">
                {{ model[0].series.key | translate }}
                {{ ' &bull; ' + model[0].name.toLocaleDateString() }}
              </div>
            }
            @if (model[0]) {
              <div class="chart-layout-bottom">
                {{ model[0].value }}
              </div>
            }
          </ng-template>
        </ngx-charts-line-chart>
      } @else {
        <div class="chart">
          <span class="is-not-enough">
            <br />
            <img src="{{ noEnoughDataImage }}" alt="" />
            <br />
            {{ 'ANALYTICS.SPEED_SCORE_MODAL.CHART.INSUFFICIENT_DATA_HEADER' | translate }}
          </span>
          <span class="is-not-enough message-not-enough">
            {{ 'ANALYTICS.SPEED_SCORE_MODAL.CHART.INSUFFICIENT_DATA_CONTENT' | translate }}
          </span>
        </div>
      }
    </div>
    <div chart-legend>
      <mat-card-actions>
        <button
          class="refresh footer"
          mat-button
          (click)="refreshButtonEvent($event)"
          [disabled]="refreshing"
          [matTooltip]="'ANALYTICS.SPEED_SCORE_MODAL.SUBTITLES.REFRESH_TOOLTIP' | translate"
          >
          <app-rotate-icon [imageUrl]="refreshImage" [animate]="refreshing"></app-rotate-icon>
        </button>
        <button class="footer" mat-button (click)="learnButtonEvent($event)" [disabled]="loading">
          {{ 'BUTTONS.LEARN_MORE' | translate }}
        </button>
        <button class="footer" mat-button (click)="improveButtonEvent($event)" [disabled]="loading">
          {{ deviceSpeedScoreInfo.improveCTAKey | translate }}
        </button>
      </mat-card-actions>
    </div>
  </app-metrics-card>
} @else {
  <div class="loading-state">
    <app-loading-state-card [header]="header"></app-loading-state-card>
  </div>
}

